import { ModifierItem } from '../../ModifierItem/redux/modifier-item-type';
import { MODIFIER_GROUP_KEY, ModifierGroupState } from './modifier-group-reducer';

export enum MODIFIER_GROUP_ACTION_TYPE {
  SET_MODIFIER_GROUP_STATE = 'SET_MODIFIER_GROUP_STATE',
  CALL_MODIFIER_GROUPS = 'CALL_MODIFIER_GROUPS',
  CALL_DELETE_MODIFIER_GROUP = 'CALL_DELETE_MODIFIER_GROUP',
  CALL_ALL_MODIFIER_GROUPS = 'CALL_ALL_MODIFIER_GROUPS',
  CALL_CREATE_MODIFIER_GROUP = 'CALL_CREATE_MODIFIER_GROUP',
  CALL_UPDATE_MODIFIER_GROUP = 'CALL_UPDATE_MODIFIER_GROUP',
}

export type ModifierGroupPaginationParams = {
  page?: number;
  limit?: number;
  keyword?: string;
};

export interface IPaginationMeta {
  itemCount: number;
  totalItems: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

export type SetModifierGroupStateAction<KeyName extends keyof ModifierGroupState> = {
  type: MODIFIER_GROUP_ACTION_TYPE.SET_MODIFIER_GROUP_STATE;
  payload: { key: KeyName; value: ModifierGroupState[KeyName] };
};

export enum ModifierGroupType {
  	OPTIONAL = 0,
    SELECT_ONE = 1,
    MULTIPLE = 2
}

export interface ModifierGroup {
  menuModifierGroupId: number;
  menuModifierGroupName: string;
  menuModifierGroupNameEN: string;
  menuModifierGroupSequence?: number;
  menuModifierGroupType: ModifierGroupType;
  menuModifierItems: ModifierItem[];
  menuModifierGroupMax: number;
}

export type CallModifierGroupsAction = {
  type: MODIFIER_GROUP_ACTION_TYPE.CALL_MODIFIER_GROUPS;
  payload?: ModifierGroupPaginationParams;
};

export type CallDeleteModifierGroupAction = {
  type: MODIFIER_GROUP_ACTION_TYPE.CALL_DELETE_MODIFIER_GROUP;
  payload: { id: number };
};

export type CallAllModifierGroupsAction = {
  type: MODIFIER_GROUP_ACTION_TYPE.CALL_ALL_MODIFIER_GROUPS;
  payload: { onSuccessCallback: (groups: ModifierGroup[]) => void };
};

export type ModifierGroupFormPayload = {
  menuModifierGroupName: string;
  menuModifierGroupNameEN?: string;
  menuModifierGroupType: number;
  menuModifierGroupItems: number[];
  menuModifierGroupMax?: number;
};

export type CallCreateModifierGroupAction = {
  type: MODIFIER_GROUP_ACTION_TYPE.CALL_CREATE_MODIFIER_GROUP;
  payload: { data: ModifierGroupFormPayload; onSuccess: () => void; onError?: (translationKeys: string[]) => void };
};

export type CallUpdateModifierGroupAction = {
  type: MODIFIER_GROUP_ACTION_TYPE.CALL_UPDATE_MODIFIER_GROUP;
  payload: { data: ModifierGroupFormPayload & { menuModifierGroupId: number }; onSuccess: () => void; onError?: (translationKeys: string[]) => void };
};

export type ModifierGroupActions = SetModifierGroupStateAction<MODIFIER_GROUP_KEY> | CallModifierGroupsAction | CallDeleteModifierGroupAction | CallAllModifierGroupsAction | CallCreateModifierGroupAction | CallUpdateModifierGroupAction;
